module.exports = __webpack_public_path__ + "img/bg-profile.85fca4ca.png";